import {useInfiniteQuery} from 'react-query';
import {MyStoreOrderTabsType} from '../../../pages/farm/myStore/pages/myStoreOrders/storeOrderTabsConfig';
import {MyStoreSettlementsTabsType} from '../../../pages/farm/myStore/pages/settlementAndPayouts/settlementTabsConfig';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import storeListOrder from './storeListOrder';

const useGetStoreListOrder = (
  order_step?: MyStoreOrderTabsType | MyStoreSettlementsTabsType,
) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-store-list-order', order_step],
    async ({pageParam = 1}) => storeListOrder({pageParam, order_step}),
    {
      enabled: Boolean(order_step),
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetStoreListOrder;
